document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('[data-placement-test-root]');
  if (!containers.length) return;

  containers.forEach(function (container) {
    initPlacementTest(container);
  });

  function initPlacementTest(container) {
    var mount = container.querySelector('[data-placement-test-mount]') || container;

    var appsScriptUrl = container.dataset.appsScriptUrl || '';
    var resultCtaLabel = container.dataset.resultCtaLabel || 'Ver opciones de grupos';
    var resultCtaUrl = container.dataset.resultCtaUrl || '';
    var buttonStyleClass = container.dataset.buttonStyleClass || 'button';
    var fullWidthDesktop = container.dataset.buttonFullWidthDesktop === 'true';
    var fullWidthMobile = container.dataset.buttonFullWidthMobile === 'true';

    var studentFirstName = '';
    var studentLastName = '';
    var studentWhatsapp = '';
    var currentQuizIndex = 0;
    var quizResults = [];
    var isSubmitting = false;

    var buttonBaseClasses = 'placement-test__btn ' + buttonStyleClass;
    if (fullWidthDesktop) {
      buttonBaseClasses += ' placement-test__btn--full-desktop';
    }
    if (fullWidthMobile) {
      buttonBaseClasses += ' placement-test__btn--full-mobile';
    }

    var quizzes = [
      {
        id: 'A1',
        levelLabel: 'A1 (Beginner)',
        title: 'A1 (Beginner)',
        questions: [
          { id: 1, text: 'She ________ a teacher.', options: { a: 'is', b: 'are', c: 'am' }, correct: 'a' },
          { id: 2, text: 'I ________ to work every day.', options: { a: 'walks', b: 'walk', c: 'walkes' }, correct: 'b' },
          { id: 3, text: 'He is ________ right now.', options: { a: 'read', b: 'reading', c: 'reads' }, correct: 'b' },
          { id: 4, text: 'There ________ some milk in the fridge.', options: { a: 'are', b: 'is', c: 'have' }, correct: 'b' },
          { id: 5, text: 'What time is class?', options: { a: 'At Dawson', b: 'On 9:00 a.m.', c: 'At 9:00 a.m.' }, correct: 'c' },
          { id: 6, text: 'How old ________ you?', options: { a: 'have', b: 'are', c: 'do' }, correct: 'b' },
          { id: 7, text: 'How ________ students are in the class?', options: { a: 'any', b: 'much', c: 'many' }, correct: 'c' },
          { id: 8, text: 'I ________ meeting my friend soon.', options: { a: 'am', b: 'be', c: 'is' }, correct: 'a' },
          { id: 9, text: 'When is ________ birthday?', options: { a: 'her', b: 'she', c: 'hers' }, correct: 'a' },
          { id: 10, text: 'Tania ________ to the store yesterday.', options: { a: 'go', b: 'goes', c: 'went' }, correct: 'c' }
        ]
      },
      {
        id: 'A2',
        levelLabel: 'A2 (Basic High)',
        title: 'A2 (Basic High)',
        questions: [
          { id: 11, text: 'I’m sorry, I ________ go to a movie this weekend.', options: { a: 'can', b: 'can’t', c: 'do not' }, correct: 'b' },
          { id: 12, text: 'Canada is ________ France.', options: { a: 'bigger', b: 'bigger than', c: 'biggest' }, correct: 'b' },
          { id: 13, text: 'They ________ go to school at 8:30.', options: { a: 'has to', b: 'have to', c: 'can to' }, correct: 'b' },
          { id: 14, text: 'He ________ basketball on Tuesdays.', options: { a: 'plays', b: 'playing', c: 'is play' }, correct: 'a' },
          { id: 15, text: 'How ________ do you visit your parents?', options: { a: 'often', b: 'about', c: 'many time' }, correct: 'a' },
          { id: 16, text: 'It’s 9:00. Where’s Jim? He’s ________ here on time.', options: { a: 'sometimes', b: 'usual', c: 'usually' }, correct: 'c' },
          { id: 17, text: 'I love these jeans! I’m going to buy ________.', options: { a: 'they', b: 'me', c: 'them' }, correct: 'c' },
          { id: 18, text: 'Malcolm is busy. He ________ his homework right now.', options: { a: 'is doing', b: 'is do', c: 'doing' }, correct: 'a' },
          { id: 19, text: 'I bought cake because there ________ any pies.', options: { a: 'wasn’t', b: 'weren’t', c: 'is not' }, correct: 'b' },
          { id: 20, text: 'Susan ________ all day yesterday.', options: { a: 'work', b: 'works', c: 'worked' }, correct: 'c' }
        ]
      },
      {
        id: 'B1',
        levelLabel: 'B1 (Intermediate)',
        title: 'B1 (Intermediate)',
        questions: [
          { id: 21, text: 'I’ve already ________ to him this morning.', options: { a: 'speak', b: 'speaked', c: 'spoken' }, correct: 'c' },
          { id: 22, text: 'Can I have ________ sugar for my tea?', options: { a: 'any', b: 'some', c: 'much' }, correct: 'b' },
          { id: 23, text: 'Mary has lived in Calgary ________ 25 years.', options: { a: 'since', b: 'for', c: 'until' }, correct: 'b' },
          { id: 24, text: 'We ________ home when we saw the accident.', options: { a: 'were walking', b: 'are walking', c: 'is walking' }, correct: 'a' },
          { id: 25, text: 'They don’t have ________ brands of makeup.', options: { a: 'much', b: 'many', c: 'some' }, correct: 'b' },
          { id: 26, text: 'She ________ dinner when the lights ________.', options: { a: 'cooked / are going out', b: 'was cooking / went out', c: 'is cooking / go out' }, correct: 'b' },
          { id: 27, text: 'If ________, ________ the shuttle.', options: { a: 'you hurry / you’ll catch', b: 'you’ll hurry / you catch', c: 'you’ll hurry / you’ll catch' }, correct: 'a' },
          { id: 28, text: 'Would you rather stay in or go out tonight? Yes, ________ go out.', options: { a: 'I rather', b: 'I’d rather', c: 'I will rather' }, correct: 'b' },
          { id: 29, text: 'My son eats ________ ice cream.', options: { a: 'many', b: 'any', c: 'a lot of' }, correct: 'c' },
          { id: 30, text: 'They’re moving in two days! They ________ start packing.', options: { a: 'have better', b: 'had better', c: 'must to' }, correct: 'b' }
        ]
      },
      {
        id: 'B2',
        levelLabel: 'B2 (Upper Intermediate)',
        title: 'B2 (Upper Intermediate)',
        questions: [
          { id: 31, text: 'Doctors tell us to avoid ________ fatty foods.', options: { a: 'to eat', b: 'eating', c: 'eats' }, correct: 'b' },
          { id: 32, text: 'The metro system ________ in the late 60s.', options: { a: 'was build', b: 'was built', c: 'builded' }, correct: 'b' },
          { id: 33, text: 'My new apartment is ________ my old one. They’re the same size.', options: { a: 'as big as', b: 'bigger', c: 'as big' }, correct: 'a' },
          { id: 34, text: 'If I ________ more money, I would go on holiday.', options: { a: 'have', b: 'had', c: 'has' }, correct: 'b' },
          { id: 35, text: 'David and Maria ________ lots of exercise, but now they go swimming every day.', options: { a: 'didn’t use to get', b: 'used to get', c: 'got used to' }, correct: 'a' },
          { id: 36, text: 'Let’s go to a movie instead of ________ TV.', options: { a: 'to watch', b: 'watching', c: 'watch' }, correct: 'b' },
          { id: 37, text: 'The Mona Lisa ________ at the Louvre Museum since 1797.', options: { a: 'shown', b: 'has showed', c: 'has been shown' }, correct: 'c' },
          { id: 38, text: '________ this picture ________ last summer?', options: { a: 'Were / took', b: 'Was / taken', c: 'Was / took' }, correct: 'b' },
          { id: 39, text: '________ coat is that?', options: { a: 'Hers', b: 'Who’s', c: 'Whose' }, correct: 'c' },
          { id: 40, text: 'I ________ you what happened if I ________.', options: { a: 'would tell / knew', b: 'won’t / knew', c: 'would tell / know' }, correct: 'a' }
        ]
      },
      {
        id: 'C1',
        levelLabel: 'C1 (Advanced)',
        title: 'C1 (Advanced)',
        questions: [
          { id: 41, text: 'The kids are bored with ________ TV. Let’s go out.', options: { a: 'to watch', b: 'watching', c: 'watch' }, correct: 'b' },
          { id: 42, text: 'It’s a beautiful day, ________?', options: { a: 'is it', b: 'isn’t it', c: 'it is' }, correct: 'b' },
          { id: 43, text: 'Jane introduced her husband to her boss because they ________ before.', options: { a: 'had never met', b: 'has never met', c: 'had never meet' }, correct: 'a' },
          { id: 44, text: 'That’s the store where you can ________ your film ________ in an hour.', options: { a: 'get / develop', b: 'have / develop', c: 'get / developed' }, correct: 'c' },
          { id: 45, text: 'Mary ________ sick anymore if she’s gone back to work.', options: { a: 'must to feel', b: 'must feel', c: 'must not feel' }, correct: 'c' },
          { id: 46, text: 'I’ll have my assistant ________ your office at the end of the day.', options: { a: 'calling', b: 'call', c: 'to call' }, correct: 'b' },
          { id: 47, text: 'Kevin told me that he ________ for the airport at 6:30.', options: { a: 'was left', b: 'was leaving', c: 'was leave' }, correct: 'b' },
          { id: 48, text: 'Will your brother get someone ________ shopping for him?', options: { a: 'going', b: 'go', c: 'to go' }, correct: 'c' },
          { id: 49, text: 'Will this situation be extended until further notice? ________.', options: { a: 'I don’t think so', b: 'I don’t guess so', c: 'I don’t hope so' }, correct: 'a' },
          { id: 50, text: 'David said ________ careful if you go out during the snowstorm.', options: { a: 'be', b: 'don’t be', c: 'to be' }, correct: 'a' }
        ]
      }
    ];

function renderIntro() {
  mount.innerHTML = '';

  var card = document.createElement('div');
  card.className = 'yk-card';

  card.innerHTML = `
    <h2 class="placement-test__intro-title">Antes de empezar...</h2>

    <div class="placement-test__fields">
      <div class="placement-test__fields-row">
        <div class="field placement-test__field">
          <input
            id="yk-first-name"
            type="text"
            class="field__input placement-test__input"
            autocomplete="given-name"
            placeholder=" "
            required
          >
          <label class="field__label" for="yk-first-name">Nombre(s)</label>
        </div>

        <div class="field placement-test__field">
          <input
            id="yk-last-name"
            type="text"
            class="field__input placement-test__input"
            autocomplete="family-name"
            placeholder=" "
            required
          >
          <label class="field__label" for="yk-last-name">Apellido(s)</label>
        </div>
      </div>

      <div class="field placement-test__field">
        <input
          id="yk-whatsapp"
          type="tel"
          class="field__input placement-test__input"
          autocomplete="tel"
          placeholder=" "
          required
        >
        <label class="field__label" for="yk-whatsapp">WhatsApp</label>
      </div>
    </div>

    <button type="button" class="${buttonBaseClasses}" data-placement-test-start>
      Empezar test
    </button>

    <div class="yk-status placement-test__status" data-placement-test-intro-status></div>
  `;

  mount.appendChild(card);

  var startBtn = card.querySelector('[data-placement-test-start]');
  var statusEl = card.querySelector('[data-placement-test-intro-status]');
  var firstnameInput = card.querySelector('#yk-first-name');
  var lastnameInput = card.querySelector('#yk-last-name');
  var whatsappInput = card.querySelector('#yk-whatsapp');

  startBtn.addEventListener('click', function () {
    var firstVal = firstnameInput.value.trim();
    var lastVal = lastnameInput.value.trim();
    var waVal = whatsappInput.value.trim();

    if (!firstVal || !lastVal || !waVal) {
      statusEl.textContent = 'Por favor llena tu nombre, apellidos y WhatsApp para continuar.';
      return;
    }

    studentFirstName = firstVal;
    studentLastName = lastVal;
    studentWhatsapp = waVal;
    currentQuizIndex = 0;
    quizResults = [];
    renderQuiz(quizzes[currentQuizIndex]);
  });
}


    function renderQuiz(quiz) {
      mount.innerHTML = '';

      var card = document.createElement('div');
      card.className = 'yk-card';

      var progressPercent = Math.round(((currentQuizIndex + 1) / quizzes.length) * 100);

      var questionsHtml = quiz.questions
        .map(function (q, idx) {
          var optionsHtml = Object.keys(q.options)
            .map(function (key) {
              var optId = 'yk-q-' + quiz.id + '-' + q.id + '-' + key;
              return `
                <label for="${optId}">
                  <input type="radio" id="${optId}" name="q-${q.id}" value="${key}">
                  <span>${q.options[key]}</span>
                </label>
              `;
            })
            .join('');

          return `
            <div class="yk-question">
              <div>${idx + 1}. ${q.text}</div>
              <div class="yk-question__options">
                ${optionsHtml}
              </div>
            </div>
          `;
        })
        .join('');

      card.innerHTML = `
        <div class="yk-quiz__meta">
          <span class="yk-badge">${quiz.levelLabel}</span>
          <span>Parte ${currentQuizIndex + 1} de ${quizzes.length}</span>
        </div>
        <div class="yk-progress">
          <div class="yk-progress__bar" style="width:${progressPercent}%;"></div>
        </div>
        <h2>${quiz.title}</h2>
        <form data-placement-test-form>
          ${questionsHtml}
          <button type="submit" class="${buttonBaseClasses}">Continuar</button>
          <div class="yk-status" data-placement-test-quiz-status></div>
        </form>
      `;

      mount.appendChild(card);

      var form = card.querySelector('[data-placement-test-form]');
      var statusEl = card.querySelector('[data-placement-test-quiz-status]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        statusEl.textContent = '';

        var score = 0;
        var total = quiz.questions.length;

        for (var i = 0; i < quiz.questions.length; i++) {
          var q = quiz.questions[i];
          var selected = form.querySelector('input[name="q-' + q.id + '"]:checked');
          if (!selected) {
            statusEl.textContent = 'Por favor responde todas las preguntas antes de continuar.';
            return;
          }
          if (selected.value === q.correct) {
            score++;
          }
        }

        handleQuizSubmit(quiz, score, total);
      });
    }

    function handleQuizSubmit(quiz, score, total) {
      quizResults.push({
        quizId: quiz.id,
        levelLabel: quiz.levelLabel,
        score: score,
        total: total
      });

      var passed = score / total >= 0.75;

      if (!passed) {
        finishTest(quiz.levelLabel);
      } else if (currentQuizIndex === quizzes.length - 1) {
        finishTest('C1 (Advanced)');
      } else {
        currentQuizIndex++;
        renderQuiz(quizzes[currentQuizIndex]);
      }
    }

    function finishTest(finalLevel) {
      mount.innerHTML = '';

      var card = document.createElement('div');
      card.className = 'yk-card';

      var friendlyLabel = finalLevel;
      var shortLevel = finalLevel.split(' ')[0];

      var extraCopy = '';

      if (shortLevel === 'A1') {
        extraCopy =
          '¡Muy bien, ' +
          studentFirstName +
          '! Aún estás en lo básico, pero con nuestra guía vas a avanzar paso a paso. Te escribiremos por WhatsApp (' +
          studentWhatsapp +
          ') con la mejor opción para tu nivel.';
      } else if (shortLevel === 'A2') {
        extraCopy =
          '¡Muy bien, ' +
          studentFirstName +
          '! Vas por buen camino; ahora te ayudaremos a pulir lo que ya sabes y avanzar al siguiente nivel. Te escribiremos por WhatsApp (' +
          studentWhatsapp +
          ') con la mejor opción para tu nivel.';
      } else if (shortLevel === 'B1') {
        extraCopy =
          '¡Muy bien, ' +
          studentFirstName +
          '! Ya puedes manejarte en situaciones del día a día; ahora toca sonar más natural y seguro. Te escribiremos por WhatsApp (' +
          studentWhatsapp +
          ') con la mejor opción para tu nivel.';
      } else if (shortLevel === 'B2') {
        extraCopy =
          '¡Muy bien, ' +
          studentFirstName +
          '! Tu inglés ya es sólido; ahora nos enfocaremos en precisión y fluidez para que te sientas completamente natural. Te escribiremos por WhatsApp (' +
          studentWhatsapp +
          ') con la mejor opción para tu nivel.';
      } else if (shortLevel === 'C1') {
        extraCopy =
          '¡Muy bien, ' +
          studentFirstName +
          '! Tu inglés es avanzado; tienes una base fuerte y ahora vamos a perfeccionar lo último. Te escribiremos por WhatsApp (' +
          studentWhatsapp +
          ') con la mejor opción para tu nivel.';
      }

      card.innerHTML = `
        <h2 class="placement-test__intro-title">Tu nivel estimado</h2>
        <div class="yk-result__level">${friendlyLabel}</div>
        <p class="yk-result__extra">
          ${extraCopy}
        </p>
        <button type="button" class="${buttonBaseClasses}" data-placement-test-result-cta>
          ${resultCtaLabel}
        </button>
        <div class="yk-status" data-placement-test-result-status></div>
      `;

      mount.appendChild(card);

      if (typeof fbq === 'function') {
        try {
          fbq('track', 'Lead', {
            testName: 'PlacementTest',
            level: finalLevel
          });
        } catch (e) {
          console.warn('fbq error', e);
        }
      }

      if (appsScriptUrl && !isSubmitting) {
        isSubmitting = true;
        var payload = {
          firstName: studentFirstName,
          lastName: studentLastName,
          whatsapp: studentWhatsapp,
          finalLevel: finalLevel,
          quizzes: quizResults
        };

        fetch(appsScriptUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain'
          },
          body: JSON.stringify(payload)
        })
          .catch(function (err) {
            console.error('Error sending placement data:', err);
          })
          .finally(function () {
            isSubmitting = false;
          });
      }

      var ctaBtn = card.querySelector('[data-placement-test-result-cta]');
      var statusEl = card.querySelector('[data-placement-test-result-status]');

      ctaBtn.addEventListener('click', function () {
        if (resultCtaUrl && resultCtaUrl !== '/') {
          window.location.href = resultCtaUrl;
        } else {
          statusEl.textContent = 'Un miembro del equipo te contactará pronto con tus opciones.';
        }
      });
    }

    // kick things off
    renderIntro();
  }
});
